import LegacyHomeComponents from './entry';

export default LegacyHomeComponents;
